import React from 'react';
import { motion } from 'framer-motion';
import { Newspaper, ArrowRight, BellRing } from 'lucide-react';
import Hero from '@/components/Hero';
import BishopWelcome from '@/components/BishopWelcome';
import QuickLinks from '@/components/QuickLinks';
import YearTheme from '@/components/YearTheme';
import UpcomingEvents from '@/components/UpcomingEvents';
import GalleryPreview from '@/components/GalleryPreview';
import SeoHead from '@/components/Seo';
import BirthdayCelebrants from '@/components/BirthdayCelebrants';
import NewsFeed from '@/components/NewsFeed'; // Activated

const Home = () => {
  return (
    <div className="min-h-screen bg-white mt-2">
      <SeoHead
        title="Welcome to Ibadan South Diocese"
        description="The Joy of the Lord, our strength"
        ogImage="https://res.cloudinary.com/dwrqyrm84/image/upload/v1750874183/home_ss1tdy.jpg"
        url="https://ibadansouthanglicandiocese.org.ng/"
      />

      {/* 1. Impact Entry */}
      <Hero />

      {/* 2. Pastoral Connection */}
      <section className="relative z-10 -mt-10 md:-mt-20">
        <BishopWelcome />
      </section>

      {/* 3. The Spiritual Focus (Year Theme) */}
      <YearTheme />

      {/* 4. News & Updates Section (Newly Activated) */}
      <section className="py-2 bg-[#fcfaf7] overflow-hidden">
        <NewsFeed />
      </section>

      {/* 5. Community Calendar */}
      <section className="py-2 bg-white">
        <UpcomingEvents />
      </section>

      {/* 6. Visual Testimony */}
      <GalleryPreview />

      {/* 7. Celebration & Links */}
      <div className="bg-slate-900 relative overflow-hidden">
        {/* Subtle texture overlay */}
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/graphy.png')]" />
        
        <div className="relative z-10">
          <BirthdayCelebrants />
          
          <div className="h-px bg-white/10 max-w-7xl mx-auto" />
          
          <QuickLinks />
        </div>
      </div>

      {/* Floating Call to Action (Newsletter) */}
      <motion.div 
        initial={{ y: 100 }}
        animate={{ y: 0 }}
        className="fixed bottom-8 right-8 z-[60] hidden sm:block"
      >
        <button className="bg-amber-500 text-white p-4 rounded-full shadow-2xl hover:bg-amber-600 transition-all flex items-center gap-3 group">
          <div className="bg-white/20 p-2 rounded-full">
            <BellRing size={20} className="animate-bounce" />
          </div>
          <span className="max-w-0 overflow-hidden group-hover:max-w-xs transition-all duration-500 font-bold uppercase tracking-widest text-[10px] whitespace-nowrap pr-2">
            Stay Updated
          </span>
        </button>
      </motion.div>
    </div>
  );
};

export default Home;